import React from "react";

export default function FeatureCard({ title, description, items }) {
  return (
    <div className=" h-[450px] rounded-lg shadow-md border border-sidom-orange bg-sidom-light dark:bg-sidom-blue overflow-hidden  flex flex-col  justify-center gap-4">
      <div>
        <div className="marca flex w-full">
          <h3 className="text-xl font-bold text-sidom-orange mb-4">{title}</h3>
        </div>
        <div className="marca">
          <p className="text-sidom-dark dark:text-sidom-light mb-4">
            {description}
          </p>
        </div>
        <div className="marca">
          <ul className="list-disc pl-5 space-y-2">
            {items.map((item, index) => (
              <li key={index} className="text-sidom-dark dark:text-sidom-light">
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
